@if (showField$ | async) {
  <mat-slide-toggle
    [attr.name]="field.name"
    [formControl]="$any(field.control)"
    >
    {{field.label | translate}}
  </mat-slide-toggle>
}
@if (field.help) {
  <mat-hint class="text-muted">{{field.help | translate}}</mat-hint>
}
